import liff from '@line/liff'
import ky from 'ky'

/**
 * Constructs a LINE API URL based on subdomain and pathname.
 */
const getLineUrl = (pathname: string, subdomain: string = 'api'): string => {
  return `https://${subdomain}.line.me/${pathname}`
}

/**
 * Ky instance for LINE API calls.
 */
export const lineClient = ky.create({
  timeout: 10000,
  hooks: {
    beforeRequest: [
      async (request) => {
        const token = liff.getAccessToken()
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`)
        }
      },
    ],
  },
})

/**
 * Map of LINE API endpoints.
 */
export const LINE_ENDPOINTS = {
  token: getLineUrl('oauth2/v2.1/token'),
  certs: getLineUrl('oauth2/v2.1/certs'),
  'openid-configuration': getLineUrl(
    '.well-known/openid-configuration',
    'access',
  ),
  authorize: getLineUrl('liff/v1/authorize', 'access'),
  profile: getLineUrl('v2/profile'),
  message: getLineUrl('message/v3/share'),
  friendship: getLineUrl('friendship/v1/status'),
  shareTargetPicker: getLineUrl('oauth2/v2.1/liff/shareTargetPicker', 'access'),
  shareTargetPickerOtt: getLineUrl('liff/v2/apps'),
  shareTargetPickerResult: getLineUrl(
    'oauth2/v2.1/liff/shareTargetPicker/result',
    'access',
  ),
  apps: getLineUrl('liff/v2/apps'),
  subWindowGetMSIT: getLineUrl('liff/v2/sub/msit'),
  subWindowGetMSTByMSIT: getLineUrl('liff/v2/sub/mst'),
  subWindowSubscribe: getLineUrl('liff/v2/sub/waitResult', 'liff'),
  subWindowPost: getLineUrl('liff/v2/sub/result'),
  subWindowGetAppData: getLineUrl('liff/v2/sub/appData'),
  subWindowGetOrigin: (id: string) => getLineUrl(`liff/v2/sub/${id}/origin`),
  accessTokenVerify: getLineUrl('oauth2/v2.1/verify'),
  unauthorizedPermissions: getLineUrl(
    'liff/v2/incrementalAgreement/unauthorizedPermissions',
    'liff',
  ),
  permanentLink: getLineUrl('liff/v2/permanentLink', 'liff'),
  createShortcutOnHomeScreen: getLineUrl('api/shortcut', 'liff-shortcut'),
  iapVirtualConfirm: getLineUrl('iap/v1/product/virtualConfirm'),
  oaAddFriendRateLimit: getLineUrl('liff/v2/oaadd/rateLimit', 'liff'),
} as const
